import React, { useState, useEffect,useContext } from "react";
import { BsCurrencyRupee, BsCurrencyDollar } from "react-icons/bs";
import './rightDetails.scss';
import candidateApi from "../../services/candidateApi";
import masterApi from "../../services/masterApi";
import { useForm, Controller } from "react-hook-form";
import { useParams } from 'react-router-dom';
import { PayTypeEnum,PayTypeEnumLabels,JobTypeEnum,JobTypeEnumLabels } from "../../enum/enum";
import { AuthContext } from "../../context/AuthContext";
import Chart from "react-apexcharts";
import { toast } from "react-toastify";

export const Package = () => {
  const { candidateIdValue, setCandidateIdValue } = useContext(AuthContext);
  const REACT_APP_DOLLER_RATE = process.env.REACT_APP_DOLLER_RATE;
  let { id } = useParams(); 
  const [candidateData, setCandidateData] = useState(null);
  const [loadedData, setLoadedData] = useState(null);
  const [companyLst, setCompanyLst] = useState([]);
  const [currencyLst, setCurrencyLst] = useState([]);
  const [selectedCurrency, setSelectedCurrency] = useState("");
  const [selectedCurrencyCode, setSelectedCurrencyCode] = useState("");
  const [isCurrencyReadonly, setIsCurrencyReadonly] = useState(true);
  const { control,register,setValue, handleSubmit, reset, formState: { errors } } = useForm();
  const [selectedCompanyId, setSelectedCompanyId] = useState(null);
  const [selectedPayType, setselectedPayType] = useState(null);  
  const [selectedNego, setselectedNego] = useState(null);
  const [selectedNegotiatedAmount, setSelectedNegotiatedAmount] = useState(null);
  const [currentCTC, setCurrentCTC] = useState(0);
  const [difference, setDifference] = useState(0);
  const [expectedCTC, setExpectedCTC] = useState(0);
  const [incrementPercentage, setIncrementPercentage] = useState(0);
  const [negotiationHistory, setNegotiationHistory] = useState([]);
  const [offeredCurrencySymbol, setOfferedCCurrencySymbol] = useState("");
  const [rates, setRates] = useState({
    yearlyINR: 0,
    yearlyUSD: 0,
    monthlyINR: 0,
    monthlyUSD: 0,
    hourlyINR: 0,
    hourlyUSD: 0,
  });

  const exchangeRates = {
    USD: process.env.REACT_APP_DOLLER_EXCHANGE_RATE,
    INR: process.env.REACT_APP_INR_EXCHANGE_RATE,
    GBP: process.env.REACT_APP_GBP_EXCHANGE_RATE,
    TWD: process.env.REACT_APP_TWD_EXCHANGE_RATE
  };  

  // If current ctc and offered ctc are in different currency type

  useEffect(() => {
    if (candidateData?.currentctc && selectedNego && selectedCurrencyCode && candidateData.currentCurrencyCode) { 
      const dollarRate = Number(REACT_APP_DOLLER_RATE) || 80;
  
      let currentCTC = Number(candidateData.currentctc);
      let offeredCTC = Number(selectedNego);
  
      let convertedCurrent = currentCTC;
      let convertedOffered = offeredCTC;
      let isDifferentCurrency = false;
  
      // Check if currency codes differ
      if (candidateData.currentCurrencyCode !== selectedCurrencyCode) {
        isDifferentCurrency = true;
  
        // Convert both to USD
        if (candidateData.currentCurrencyCode === "INR") {
          convertedCurrent = currentCTC / dollarRate;
        } else if (candidateData.currentCurrencyCode === "USD") {
          convertedCurrent = currentCTC; // already in USD
        } else if (candidateData.currentCurrencyCode === "GBP") {
          convertedCurrent = currentCTC / (exchangeRates["GBP"] || 100);
        } else if (candidateData.currentCurrencyCode === "TWD") {
          convertedCurrent = currentCTC / (exchangeRates["TWD"] || 30);
        }
  
        if (selectedCurrencyCode === "INR") {
          convertedOffered = offeredCTC / dollarRate;
        } else if (selectedCurrencyCode === "USD") {
          convertedOffered = offeredCTC; // already in USD
        } else if (selectedCurrencyCode === "GBP") {
          convertedOffered = offeredCTC / (exchangeRates["GBP"] || 100);
        } else if (selectedCurrencyCode === "TWD") {
          convertedOffered = offeredCTC / (exchangeRates["TWD"] || 30);
        }
      }
  
      const calculatedDifference = convertedOffered - convertedCurrent;
      const percentage = (calculatedDifference / convertedCurrent) * 100;
  
      setDifference(calculatedDifference.toFixed(2));
      setIncrementPercentage(percentage.toFixed(2));
  
      // Set these for display
      setCurrentCTC(currentCTC);
      setExpectedCTC(offeredCTC);
  
    } else {
      setDifference(0);
      setIncrementPercentage(0);
    }
  }, [candidateData, selectedNego, selectedCurrencyCode]);

  const getCurrencyCode = async (respData) => {
    if(respData.candidatePackage[0]?.currencyId){
      try{
        const resp = await masterApi.getCurreniesById(respData.candidatePackage[0]?.currencyId); 
        if (resp?.data) { 
          setSelectedCurrencyCode(resp.data.code);  
        }
      }
      catch (error) {
        toast.error("Error fetching currency data", {
                  position: "top-right", 
                  autoClose: 2000,
                });
        console.error("Error fetching currency data:", error);
      }
    } 
  }

  // load page data
  const loadData = async (id,selectedCompanyId) => {  
    try {
      selectedCompanyId = selectedCompanyId === null || selectedCompanyId === undefined ? 0 : selectedCompanyId; 
      const response = await candidateApi.getCandidatePackageAndNegotiationHistory(id,selectedCompanyId); 
      if (response?.data) { 
        setLoadedData(response.data); 
        console.log("Fetched Data:", response.data); 
      if (response.data.candidatePackage[0]?.companyId) {
        setSelectedCompanyId(response.data.candidatePackage[0]?.companyId); 
        setValue("companyId", response.data.candidatePackage[0]?.companyId);  
        setSelectedCurrency(response.data.candidatePackage[0]?.currencyId); 
        setValue("currencyId", response.data.candidatePackage[0]?.currencyId);  
        setOfferedCCurrencySymbol(response.data.candidatePackage[0]?.symbol);
        getCurrencyCode(response.data);
        setselectedPayType(response.data.candidatePackage[0]?.payType);  
        setselectedPayType(response.data.candidatePackage[0]?.payType);
        setValue("amountIn", response.data.candidatePackage[0]?.payType);
        let negotiatedAmount = response.data.candidatePackage[0]?.offeredCTC;
        setSelectedNegotiatedAmount(response.data.candidatePackage[0]?.offeredCTC);
        if (response.data.candidatePackage[0]?.payType === "Monthly") {
          negotiatedAmount = negotiatedAmount * 12;
        } else if (response.data.candidatePackage[0]?.payType === "Hourly") {
          const workingHoursPerDay = 8;
          const workingDaysPerMonth = 21;
          const hoursPerMonth = workingHoursPerDay * workingDaysPerMonth;
          const hoursPerYear = hoursPerMonth * 12;
          negotiatedAmount = negotiatedAmount * hoursPerYear; // Convert hourly to yearly
        }
        setselectedNego(negotiatedAmount);
        setValue("negotiated", negotiatedAmount);
        setCurrentCTC(response.data.candidatePackage[0]?.currentctc);
      }
      const historyData = response.data.negotiationHistory
      ? Object.values(response.data.negotiationHistory)
      : [];
      setNegotiationHistory(historyData);      
      }
    } catch (error) {
      toast.error("Error fetching package data", {
                position: "top-right", 
                autoClose: 2000,
              });
      console.error("Error fetching package data:", error);
    }
  };
  useEffect(() => {    
    loadData(id,selectedCompanyId); 
  }, [id,selectedCompanyId]);
 // Candidate difference
//  useEffect(() => {
//   if (candidateData?.currentctc && selectedNego) {
//     const calculatedDifference = selectedNego - candidateData.currentctc;
//     setDifference(calculatedDifference);
//     const percentage =
//     (calculatedDifference / candidateData.currentctc) * 100;
//     setIncrementPercentage(percentage.toFixed(2));
//     setCurrentCTC(candidateData.currentctc || 0);
//     setExpectedCTC(selectedNego || 0);
//   } else {
//     setDifference(0);
//     setIncrementPercentage(0);
//   }
// }, [candidateData, selectedNego]);  
  // fetch candidate details
  const fetchData = async () => { 
    try {
      const response = await candidateApi.getCandidateById(id); // Call API with the ID     
      if (response?.data) { 
        // setCandidateData(response.data); 
        setCandidateData({
          ...response.data,
          currencyCode: response.data.currencyCode // ensure your API gives this
        });
        console.log("Fetched Data:", response.data);
      }
    } catch (error) {
      toast.error("Error fetching candidate details", {
                position: "top-right", 
                autoClose: 2000,
              });
      console.error("Error fetching candidate details:", error);
    }
  };
  useEffect(() => {
    if (!id){
      id=candidateIdValue;
    }
    fetchData();
  }, [id]);
 useEffect(() => {
  const loadCompanies = async () => {
    try {
      const response = await masterApi.getActiveCompanies();
      setCompanyLst(response?.data?.companyList || []);
    } catch (error) {
      toast.error("Error fetching companies", {
                position: "top-right", 
                autoClose: 2000,
              });
      console.error("Error fetching companies:", error);
    }
  };
  const loadCurrencies = async () => {
    try {
      const response = await masterApi.getActiveCurrenies();
      setCurrencyLst(response?.data?.activeCurrenies || []);      
    } catch (error) {
      toast.error("Error fetching currencies", {
                position: "top-right", 
                autoClose: 2000,
              });
      console.error("Error fetching currencies:", error);
    }
  };
  loadCompanies();
  loadCurrencies();
}, []);
  // Handle company selection
  const handleCountryChange = (e) => {
    const companyId = parseInt(e.target.value); 
    setSelectedCompanyId(companyId); 
    setselectedNego("");
    setCurrentCTC("");
    setSelectedNegotiatedAmount("");
    const selectedCompany = companyLst.find(
    (company) => company.id === companyId
  );
    if (selectedCompany) {
      const correspondingCurrency = currencyLst.find(
      (currency) => currency.countryId === selectedCompany.countryId
    );     
      if (correspondingCurrency) {
        setSelectedCurrency(correspondingCurrency.id); 
        setSelectedCurrencyCode(correspondingCurrency.code); 
        setValue("currencyId", correspondingCurrency.id); 
      } else {
        setSelectedCurrency(""); 
        setValue("currencyId", "");
        setIsCurrencyReadonly(true);
      }
    } else {
      setSelectedCurrency(""); 
      setValue("currencyId", "");
      setIsCurrencyReadonly(true);
    }
  };
  const onSubmit = async (data) => {  
    const requestData = {
        candidateId: id,
        companyId: data.companyId,
        currencyId: data.currencyId,
        payType: data.amountIn,
        amount: data.negotiationAmount,
        comment:data.comment
    };
    try {
      const response = await candidateApi.insertNegotiationHistory(requestData);
      console.log("Package inserted successfully:", response);
      if (response.status === 200) {        
        reset();
        toast.success("Package submitted successfully", {
                  position: "top-right", 
                  autoClose: 2000,
                });
        const response = await candidateApi.getCandidatePackageAndNegotiationHistory(id,selectedCompanyId); 
        if (response?.data) { 
          setLoadedData(response.data); 
          console.log("Fetched Data:", response.data); 
          if (response.data.candidatePackage[0]?.companyId) {
            setSelectedCompanyId(response.data.candidatePackage[0]?.companyId); 
            setValue("companyId", response.data.candidatePackage[0]?.companyId);      
            setSelectedCurrency(response.data.candidatePackage[0]?.currencyId);  
            setValue("currencyId", response.data.candidatePackage[0]?.currencyId);     
            setselectedPayType(response.data.candidatePackage[0]?.payType);  
            setselectedPayType(response.data.candidatePackage[0]?.payType);
            setValue("amountIn", response.data.candidatePackage[0]?.payType);    
            let negotiatedAmount = response.data.candidatePackage[0]?.offeredCTC;
            setSelectedNegotiatedAmount(response.data.candidatePackage[0]?.offeredCTC);
            setOfferedCCurrencySymbol(response.data.candidatePackage[0]?.symbol);
            if (response.data.candidatePackage[0]?.payType === "Monthly") {
              negotiatedAmount = negotiatedAmount * 12; 
            } else if (response.data.candidatePackage[0]?.payType === "Hourly") {
              const workingHoursPerDay = 8;
              const workingDaysPerMonth = 21;
              const hoursPerMonth = workingHoursPerDay * workingDaysPerMonth;
              const hoursPerYear = hoursPerMonth * 12;    
              negotiatedAmount = negotiatedAmount * hoursPerYear; 
            }
            setselectedNego(negotiatedAmount);
            setValue("negotiated", negotiatedAmount);    
            setCurrentCTC(response.data.candidatePackage[0]?.currentctc);

            getCurrencyCode(response.data);
            
          }
        const historyData = response.data.negotiationHistory
        ? Object.values(response.data.negotiationHistory)
        : [];
        setNegotiationHistory(historyData);      
        }        
      }
    } catch (error) {
      toast.error("Error updating package", {
                position: "top-right", 
                autoClose: 2000,
              });
      console.error("Error submitting package:", error);
    }
  };  
  const convertDate = (dateString) => {
    const date = new Date(dateString);  
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); 
    const year = String(date.getFullYear()).slice(-2);  
    return `${day}/${month}/${year}`;
  };
  const calculateRates = () => {  
    const hoursPerDay = 8; 
    const workingDaysPerMonth = 21; 
    const hoursPerMonth = hoursPerDay * workingDaysPerMonth; 
    const hoursPerYear = hoursPerMonth * 12; 
    // const conversionRate = Number(REACT_APP_DOLLER_RATE) || 80;  
    // const conversionRate = 29.96; 
    let yearlyINR = 0, 
        monthlyINR = 0, 
        hourlyINR = 0, 
        yearlyUSD = 0, 
        monthlyUSD = 0, 
        hourlyUSD = 0;  
    let yearlyAmount = Number(selectedNego) || 0;
    const selectedCode = selectedCurrencyCode; 
    if (selectedCode === "INR") {
      const conversionRate=Number(process.env.REACT_APP_INR_EXCHANGE_RATE);
      yearlyINR = yearlyAmount;
      yearlyUSD = yearlyINR / conversionRate;
    } 
    else if (selectedCode === "TWD"){
      const conversionRate=Number(process.env.REACT_APP_TWD_EXCHANGE_RATE);
      yearlyINR = yearlyAmount;
      yearlyUSD = yearlyINR / conversionRate;
    }
    else if (selectedCode === "GBP"){
      const conversionRate=Number(process.env.REACT_APP_GBP_EXCHANGE_RATE);
      yearlyINR = yearlyAmount;
      yearlyUSD = yearlyINR / conversionRate;
    }
    else if (selectedCode === "USD") {
      const conversionRate=Number(process.env.REACT_APP_DOLLER_EXCHANGE_RATE);
      yearlyUSD = yearlyAmount;
      yearlyINR = yearlyUSD * conversionRate;
    }
    monthlyINR = yearlyINR / 12;
    hourlyINR = yearlyINR / hoursPerYear;
    monthlyUSD = yearlyUSD / 12;
    hourlyUSD = yearlyUSD / hoursPerYear;
    return {
      yearlyINR: Math.max(0, Math.round(yearlyINR * 100) / 100),
      yearlyUSD: Math.max(0, Math.round(yearlyUSD * 100) / 100),
      monthlyINR: Math.max(0, Math.round(monthlyINR * 100) / 100),
      monthlyUSD: Math.max(0, Math.round(monthlyUSD * 100) / 100),
      hourlyINR: Math.max(0, Math.round(hourlyINR * 100) / 100),
      hourlyUSD: Math.max(0, Math.round(hourlyUSD * 100) / 100),
    };
  }; 
  useEffect(() => {
    const calculatedRates = calculateRates();
    setRates((prev) => ({
      ...prev,
      ...calculatedRates,
    }));
  }, [selectedNego, selectedCurrency]);

  const getDifferenceArray = (value, divident) => {
    const equalParts = Math.floor(value / divident);
    let array = [];
    for(let i=0; i<=divident; i++){
      array.push(i * equalParts)
    }

    return array
  }

  const getCurrentCTCArray = (value, percent) => {
    const elementLength = percent <= 100 ? 100 / 5 : 125 / 5;
    const ctcArray = Array.from({length: elementLength + 1}, (_, i) => value)
    
    return ctcArray
  }
  
  const getOfferedCTCArray = (percent) => {
    const elementLength = percent <= 100 ? 100 / 5 : 125 / 5;
    let ctcArray = []
    if(negotiationHistory.length > 1){
      const maxVal = Math.max(...Array.from(negotiationHistory, item => item.amount))
      const minVal = Math.min(...Array.from(negotiationHistory, item => item.amount))
      const step = (maxVal - minVal) / (elementLength - 1);
      ctcArray = Array.from({ length: elementLength + 1}, (_, i) => Math.round(minVal + i * step));
    }else if(negotiationHistory.length === 1){
      ctcArray = Array.from({length: elementLength + 1}, (_, i) => negotiationHistory?.[0].amount)
    }else{
      ctcArray = Array.from({length: elementLength + 1}, (_, i) => 0)

    }

    return ctcArray
  }


  const options = {
    chart: {
      id: "line-chart",
    },
    xaxis: {
      categories: Array.from({ length: 126 / 5 + 1 }, (_, i) => i * 5),
    },
    stroke: {
      curve: "straight",
      width: 2,
      lineCap: 'round',
    },
    markers: {
      size: 3,            
      colors: ["#04268c", "#126603", "#f06f3c"], 
      strokeColor: "#fff", 
      strokeWidth: 2,
      shape: "circle",   
      hover: {
        size: 7          
      },
    }
    
  };


  const series = [
    {
      name: "Current CTC",
      data: getCurrentCTCArray(candidateData?.currentctc || 0, incrementPercentage || 100),
      color: "#04268c"
    },
    {
      name: "Offered",
      data: getOfferedCTCArray(incrementPercentage || 100),
      color: "#126603",
    },
    {
      name: "Difference",
      data: getDifferenceArray(difference || 0, Math.floor(incrementPercentage / 5)),
      color: "#f06f3c",
    },
  ];

  

  return (
    <section className="row">
      <div className="col-12 col-md-7 ">
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="row">
          <div className="col-4 col-md-8 mb-3 position-relative">
            <label className="form-label">
              Company 
            </label>
            <Controller
              name="companyId"
              control={control}
              rules={{
                required: 'Company is required', // Validation rule
              }}
              render={({ field }) => (
            <select {...field}
              className={`form-select ${errors.companyId ? "is-invalid" : ""}`} onChange={(e) => {
                field.onChange(e); // Update react-hook-form value
                handleCountryChange(e); // Trigger your custom logic
              }} >
              <option value="0">Select</option>
              {companyLst.map((company) => (
                <option key={company.id} value={company.id}>
                  {company.companyName}
                </option>
              ))}
            </select>
            )} />
          </div>
          <div className="col-4 col-md-4 mb-3 position-relative">
            <label className="form-label">
              Currency
            </label>
            <Controller
            name="currencyId"
            control={control}     
            rules={{ required: 'Currency is required' }}       
            render={({ field }) => (
            <select {...field}
              className={`form-select ${errors.currencyId ? 'is-invalid' : ''}`}
              value={candidateData?.currentCurrencyId}
              disabled={true ? candidateData?.currentCurrencyId : false}
              // value={selectedCurrency} 
            >
              <option value="">Select</option>
              {currencyLst.map((currency) => (
                <option key={currency.id} value={currency.id}>
                {currency.name}
              </option>
              ))}
            </select>
        )} />
          </div>
        </div>
        <div className="row">
          <div className="col-4 col-md-4 mb-4 position-relative">
            <label className="form-label">
              Amount In
            </label>
            <Controller
              name="amountIn"
              control={control}
              rules={{
                required: 'Amount In is required', // Validation rule
              }}
              render={({ field }) => (
            <select
              className={`form-select ${errors.amountIn ? "is-invalid" : ""}`} id="amountIn" onChange={(e) => {
                field.onChange(e); }} value={selectedPayType} >
              <option>Select</option>
              {Object.keys(PayTypeEnum || {}).map((key) => (
                <option key={key} value={PayTypeEnum[key]}>
                  {PayTypeEnumLabels[PayTypeEnum[key]]}
                </option>
              ))}
            </select>
              )} />
          </div>
          <div className="col-4 col-md-5 mb-4 position-relative">
            <label className="form-label">
              Negotiated Amount
            </label>
            <input className="form-control" readOnly value={selectedNegotiatedAmount} id="negotiated"/>
          </div>
        </div>
        <div className="datatable-holder mb-4">
          <div className="re-row d-flex align-items-center p-2">
            <label className="form-label mb-0 w-50">
              Amount In
            </label>
            {candidateData ? (
            <p className="mb-0">
              {/* <span><BsCurrencyRupee /></span> */}
              <span>{candidateData.currentCurrencySymbol}</span>
              {candidateData.currentctc}

            </p>
            ) : (
              <p>0</p>
            )}
          </div>
          <div className="re-row d-flex align-items-center p-2">
            <label className="form-label mb-0 w-50">
              Expected CTC
            </label>
            {candidateData ? (
            <p className="mb-0">
              {/* <span><BsCurrencyRupee /></span> */}
              <span>{candidateData.expectedCurrencySymbol}</span>
              {candidateData.expectedctc}
            </p>
            ) : (
              <p>0</p>
            )}
          </div>
          <div className="re-row d-flex align-items-center p-2">
            <label className="form-label mb-0 w-50">
              Offered CTC
            </label>
            <p className="mb-0">
              {/* <span><BsCurrencyRupee /></span> */}
              <span>{offeredCurrencySymbol}</span>
              {selectedNego ? selectedNego : 0}
            </p>
          </div>
        </div>
        <h6 className="mb-2">Negotiation</h6>
        <div className="row">
          <div className="col-12 col-md-3 mb-4 position-relative">
            <label className="form-label">
              Amount ({offeredCurrencySymbol})
            </label>
            <input {...register("negotiationAmount", {
                    required: "Negotiation Amount is required",
                  })} className={`${errors.negotiationAmount ? "form-control required" : "form-control"
                  }`} id="negotiationAmount"
                  type="number"
                  min={0}/>
          </div>
          <div className="col-12 col-md-7 mb-4 position-relative">
            <label className="form-label">
              Comments
            </label>
            <input {...register("comment", )} className="form-control" />
          </div>
          <div className="col-12 col-md-2 mb-4 position-relative">
            <label className="form-label d-block visibility-hidden">
              Action
            </label>
            <button type="submit" className="btn btn-primary w-100" >
              Update
            </button>
          </div>
        </div>
        </form>

        {negotiationHistory.length === 0 ? (
        <p>No negotiation history available.</p>
      ) : (
        <div className="datatable-holder mb-4">
          <div className="re-row d-flex align-items-center ">
            <div className="col-md-3 p-2">
              <label className="form-label mb-0">
                Amount
              </label>
            </div>
            <div className="col-md-7 p-2">
              <label className="form-label mb-0">
                Comments
              </label>
            </div>
            <div className="col-md-2 p-2">
              <label className="form-label mb-0">
                Date
              </label>
            </div>
          </div>
        {negotiationHistory.map((history) => (
          <div className="re-row d-flex align-items-center">
            <div className="col-md-3 p-2">
              <p className="mb-0">
                <span>{history.symbol}</span>
                {history.amount}
              </p>
            </div>
            <div className="col-md-7 p-2">
              <p className="mb-0">
              {history.comment}
              </p>
            </div>
            <div className="col-md-2 p-2">
              <p className="mb-0">
                {convertDate(history.createdAt)}
              </p>
            </div>
          </div>
        ))}
        </div>
        )}
      </div>
      <div className="col-12 col-md-5 with-border position-relative ">
      <div className="datatable-holder mb-4">
          <div className="re-row d-flex align-items-center ">
            <div className="col-md-4 p-2">
              <label className="form-label mb-0 fw-semibold">
                Currency
              </label>
            </div>
            {selectedCurrencyCode != "USD" && <div className="col-md-4 p-2">
              <label className="form-label mb-0 fw-semibold">
                {selectedCurrencyCode}
              </label>
            </div>}
            <div className="col-md-4 p-2">
              <label className="form-label mb-0 fw-semibold">
                Dollar
              </label>
            </div>
          </div>
          <div className="re-row d-flex align-items-center">
          <div className="col-md-4 p-2">
              <p className="mb-0">
                Hourly
              </p>
            </div>
            {selectedCurrencyCode != "USD" && <div className="col-md-4 p-2">
              <p className="mb-0">
                <span>{offeredCurrencySymbol}</span>
                {rates.hourlyINR}
              </p>
            </div>}
            <div className="col-md-4 p-2">
              <p className="mb-0">
                <span><BsCurrencyDollar /></span>
               {rates.hourlyUSD}
              </p>
            </div>
            </div>
            <div className="re-row d-flex align-items-center">
            <div className="col-md-4 p-2">
              <p className="mb-0">
                Monthly
              </p>
            </div>
            {selectedCurrencyCode != "USD" && <div className="col-md-4 p-2">
              <p className="mb-0">
                <span>{offeredCurrencySymbol}</span>
                {rates.monthlyINR}
              </p>
            </div>}
            <div className="col-md-4 p-2">
              <p className="mb-0">
                <span><BsCurrencyDollar /></span>
                {rates.monthlyUSD}
              </p>
            </div>
          </div>
          <div className="re-row d-flex align-items-center">
          <div className="col-md-4 p-2">
              <p className="mb-0">
                Yearly
              </p>
            </div>
            {selectedCurrencyCode != "USD" && <div className="col-md-4 p-2">
              <p className="mb-0">
                <span>{offeredCurrencySymbol}</span>
                {rates.yearlyINR}
              </p>
            </div>}
            <div className="col-md-4 p-2">
              <p className="mb-0">
                <span><BsCurrencyDollar /></span>
                {rates.yearlyUSD}
              </p>
            </div>
            </div>
            </div>
        <div className="datatable-holder mb-4">
          <div className="re-row d-flex align-items-center p-2">
            <label className="form-label mb-0 w-50">
              Current CTC
            </label>
              {candidateData ? (
                <p className="mb-0">
                  {/* <span><BsCurrencyRupee /></span> */}
                  <span>{candidateData.currentCurrencySymbol}</span> {candidateData.currentctc}
                </p>
              ) : (
                <p className="mb-0">
                  <span><BsCurrencyRupee /></span>
                  0
                </p>
              )}
          </div>
          <div className="re-row d-flex align-items-center p-2">
            <label className="form-label mb-0 w-50">
            Offered
            </label>
            {selectedNego ? (
            <p className="mb-0">
              <span>{offeredCurrencySymbol}</span> {selectedNego}
            </p>            
            ) : (
              <p className="mb-0">
              <span><BsCurrencyRupee /></span>
              0
                </p>
              )}
          </div>
          <div className="re-row d-flex align-items-center p-2">
            <label className="form-label mb-0 w-50">
            Difference
            </label>
            <p className="mb-0">
              {/* <span><BsCurrencyRupee /></span>
              {difference} */}
              <span>{offeredCurrencySymbol}</span> {difference}
            </p>
          </div>
          <div className="re-row d-flex align-items-center p-2">
            <label className="form-label mb-0 w-50">
            Increment
            </label>
            <p className="mb-0">
              {/* <span><BsCurrencyRupee /></span>
              {incrementPercentage}% */}
              <span>{offeredCurrencySymbol}</span> {incrementPercentage}%
            </p>
          </div>
        </div> 

        <div className="chart-holder">
        <Chart options={options} series={series} type="line" height={350} />
        </div>
        </div>
    </section>
  );
}

